<script lang="ts" setup>
  withDefaults(
    defineProps<{
      id: string
      labelledBy?: string
    }>(),
    {
      labelledBy: ''
    }
  )

  const switchState = defineModel<boolean>('modelValue')
</script>

<template>
  <SwitchRoot
    :id="id"
    v-model:checked="switchState"
    :aria-labelledby="labelledBy || undefined"
    class="relative flex h-8 w-15 cursor-pointer rounded-full bg-border outline-none focus-within:outline focus-within:outline-2 focus-within:outline-bt-blue-ui data-[state=checked]:bg-bt-blue-ui"
  >
    <SwitchThumb
      class="my-auto block size-6 translate-x-1 rounded-full bg-white transition-transform duration-500 will-change-transform data-[state=checked]:translate-x-8"
    />
  </SwitchRoot>
</template>
